import { standardDrawing } from '@moleculeone/draw';
import { Mol } from '@moleculeone/types';
import { expandToMinSize, V4, wait } from '@moleculeone/utils';
import { useEffect, useState } from 'react';

type UseMolDrawingArgs = {
  mol: Mol;
  renderDelay?: number;
};
export const useMolDrawing = ({ mol, renderDelay = 0 }: UseMolDrawingArgs) => {
  const [drawing, setDrawing] = useState<{ drawnMol: any; viewport: any } | null>(null);

  useEffect(() => {
    async function calculate() {
      await wait(renderDelay);
      const drawnMol = standardDrawing(mol) as any;
      const bbox = drawnMol.bbox;
      const viewport = expandToMinSize(bbox, V4.fromArray([24, 24, 0]));
      setDrawing({ drawnMol, viewport });
    }
    calculate();
  }, [mol]);

  return drawing;
};
